export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Catégorie\",\n    \"label_other\": \"{{count}} catégories\"\n}\n"